import { Component } from "@angular/core";
import { ToastService } from "src/services/toast.service";

@Component({
  selector: "vw-toasts",
  templateUrl: "./toasts.component.html",
})
export class ToastsComponent {
  constructor(public toastService: ToastService) {}

  deleteToast(toastId: string): void {
    this.toastService.deleteToast(toastId);
  }
}
